import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class Feedback extends ApiBase {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/feedback`)
  }

  rateCriterionList(filter, showProgress) {
    return this._request({
      action: 'rateCriterion/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  respond(model, id, showProgress) {
    return this._request({
      action: `${ id }/respond`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }
}
